import { render } from "./NotificationEditor.vue?vue&type=template&id=e11e2a08"
import script from "./NotificationEditor.vue?vue&type=script&lang=js"
export * from "./NotificationEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/linuxbasic/GitProjects/caru-platform-api/systems/caru-cloud-platform/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__